import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import { useForm } from 'react-hook-form';

import FormController from 'portal/src/components/common/forms/FormController';

const ABANDON_REASONS = [
  'Insufficient statement image quality',
  'Statement is not a bill',
  'Statement has invalid format',
  'Statement uploaded by mistake',
  'Statement is a duplicate',
  'Statement is missing pages',
];

const ConfirmIgnoreDialog = ({
  open,
  isLoading,
  onClose,
  onCancel,
  onConfirm,
}: {
  open: boolean;
  isLoading: boolean;
  onClose: () => void;
  onCancel: () => void;
  onConfirm: (reason: string) => void;
}) => {
  const { control, handleSubmit, reset } = useForm<{ reason: string }>({
    defaultValues: {
      reason: '',
    },
  });

  const handleClose = () => {
    reset();
    onClose();
  };

  const handleCancel = () => {
    reset();
    onCancel();
  };

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
      <DialogTitle>Ignore Statement</DialogTitle>
      <DialogContent>
        <Typography variant="body1">
          Are you sure you want to ignore this statement?
          <br />
          If so, please select a reason and confirm:
        </Typography>
        <Box sx={{ pt: 1 }}>
          <FormController
            control={control}
            fieldConf={{
              label: 'Reason',
              name: 'reason',
              placeholder: 'Reason',
              required: true,
              type: 'selectInput' as const,
              values: ABANDON_REASONS.map((reason) => ({
                label: reason,
                value: reason,
              })),
            }}
          />
        </Box>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button
          color="info"
          variant="outlined"
          disabled={isLoading}
          onClick={handleCancel}
        >
          Cancel
        </Button>
        <Button
          color="error"
          onClick={handleSubmit(({ reason }) => onConfirm(reason))}
          loading={isLoading}
          loadingPosition="end"
          variant="contained"
        >
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmIgnoreDialog;
